
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _4045dklIIvZu8Meta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/404.vue?macro=true";
import { default as _500CTVwgshq1HMeta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/500.vue?macro=true";
import { default as chartiBpRWBpED2Meta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/chart.vue?macro=true";
import { default as errorC7h2vZPb87Meta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/error.vue?macro=true";
import { default as indexHeGojNabpMMeta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/index.vue?macro=true";
import { default as loginxcufuzvrdmMeta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/login.vue?macro=true";
import { default as registration4IJ7qXND80Meta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/registration.vue?macro=true";
import { default as testWQ1mt6VqnHMeta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/test.vue?macro=true";
import { default as userProfileAQOZNHyvG6Meta } from "/var/lib/jenkins/workspace/mdm.softminds.net/pages/userProfile.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _4045dklIIvZu8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/404.vue")
  },
  {
    name: "500",
    path: "/500",
    meta: _500CTVwgshq1HMeta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/500.vue")
  },
  {
    name: "chart",
    path: "/chart",
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/chart.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errorC7h2vZPb87Meta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexHeGojNabpMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginxcufuzvrdmMeta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/login.vue")
  },
  {
    name: "registration",
    path: "/registration",
    meta: registration4IJ7qXND80Meta || {},
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/registration.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/test.vue")
  },
  {
    name: "userProfile",
    path: "/userProfile",
    component: () => import("/var/lib/jenkins/workspace/mdm.softminds.net/pages/userProfile.vue")
  }
]